import { render } from "./in_review.vue?vue&type=template&id=3692d105"
import script from "./in_review.vue?vue&type=script&lang=js"
export * from "./in_review.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__